import type { SVGProps } from 'react';

export const PDFIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.5L0.999999 1.5L1 16.5L15 16.5L15 6.5L10 1.5Z"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1.5L10 6.5L15 6.5"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.4 10H7V13H7.4C8.28368 13 9 12.3284 9 11.5C9 10.6716 8.28368 10 7.4 10Z"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13V10H12.5"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 12H12"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 13V11.875M3.5 11.875V10H4.25C4.94036 10 5.5 10.4197 5.5 10.9375C5.5 11.4553 4.94036 11.875 4.25 11.875H3.5Z"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
